import * as THREE from 'three';
import occtimportjs from 'occt-import-js';

const wasmUrl = '/occt-import-js.wasm'; // Local WASM file in public folder

// Function to calculate volume of a triangulated mesh (unused now)
function calculateVolume(geometry) {
  const positions = geometry.getAttribute('position').array;
  const indices = geometry.getIndex().array;
  let volume = 0;

  for (let i = 0; i < indices.length; i += 3) {
    const v1 = new THREE.Vector3(
      positions[indices[i] * 3],
      positions[indices[i] * 3 + 1],
      positions[indices[i] * 3 + 2]
    );
    const v2 = new THREE.Vector3(
      positions[indices[i + 1] * 3],
      positions[indices[i + 1] * 3 + 1],
      positions[indices[i + 1] * 3 + 2]
    );
    const v3 = new THREE.Vector3(
      positions[indices[i + 2] * 3],
      positions[indices[i + 2] * 3 + 1],
      positions[indices[i + 2] * 3 + 2]
    );

    const tetraVolume = v1.dot(v2.clone().cross(v3)) / 6;
    volume += tetraVolume;
  }

  return Math.abs(volume);
}

export async function LoadStep(file) {
  const targetObject = new THREE.Object3D();

  // Initialize occt-import-js
  const occt = await occtimportjs({
    locateFile: (path) => {
      console.log('Locating file:', path);
      if (path.endsWith('.wasm')) return wasmUrl;
      return path;
    },
  }).catch((err) => {
    console.error('occt-import-js initialization error:', err);
    throw err;
  });

  console.log('occt object:', occt);
  console.log('ReadStepFile available:', typeof occt.ReadStepFile);

  if (typeof occt.ReadStepFile !== 'function') {
    throw new Error('ReadStepFile is not a function on the occt object. Available methods:', Object.keys(occt).join(', '));
  }

  // Read the file as ArrayBuffer
  const arrayBuffer = await file.arrayBuffer();
  const fileBuffer = new Uint8Array(arrayBuffer);
  const result = occt.ReadStepFile(fileBuffer);

  // Process the geometries and add meshes to the target object.
  for (let resultMesh of result.meshes) {
    let geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(resultMesh.attributes.position.array, 3));
    if (resultMesh.attributes.normal) {
      geometry.setAttribute('normal', new THREE.Float32BufferAttribute(resultMesh.attributes.normal.array, 3));
    }
    const index = Uint16Array.from(resultMesh.index.array);
    geometry.setIndex(new THREE.BufferAttribute(index, 1));

    let material = null;
    if (resultMesh.color) {
      const color = new THREE.Color(resultMesh.color[0], resultMesh.color[1], resultMesh.color[2]);
      material = new THREE.MeshPhongMaterial({ color: color });
    } else {
      material = new THREE.MeshPhongMaterial({ color: 0xcccccc });
    }

    const mesh = new THREE.Mesh(geometry, material);
    targetObject.add(mesh);
  }

  // Calculate bounding box volume
  const boundingBox = new THREE.Box3().setFromObject(targetObject);
  const boxSize = new THREE.Vector3();
  boundingBox.getSize(boxSize);
  const boundingVolume = boxSize.x * boxSize.y * boxSize.z;

  const inchBuffer = 25.4 / 8; // 1/8 inch in mm (~3.175 mm)
const bufferedWidth = boxSize.x + inchBuffer;
const bufferedHeight = boxSize.y + inchBuffer;
const bufferedDepth = boxSize.z + inchBuffer;

  const bufferVolume = bufferedWidth * bufferedHeight * bufferedDepth;

  // Conversion function: 1 cubic inch ≈ 16387.064 cubic millimeters
  const mm3ToInches = (v) => v / 16387.064;
  const mmToInches = (v) => v / 25.4;

  console.log('Calculated bounding box volume:', mm3ToInches(boundingVolume), 'cubic inches');
  console.log('Box size X:', mmToInches(boxSize.x));
  console.log('Box size Y:', mmToInches(boxSize.y));
  console.log('Box size Z:', mmToInches(boxSize.z));

  console.log('Buffered box size X:', mmToInches(bufferedWidth));
  console.log('Buffered box size Y:', mmToInches(bufferedHeight));
  console.log('Buffered box size Z:', mmToInches(bufferedDepth));

  console.log('Buffered bounding box volume:', mm3ToInches(bufferVolume), 'cubic inches');

  // Attach the volumes and dimensions to the object as properties
  targetObject.userData.volume = boundingVolume; // raw volume in mm³
  targetObject.userData.bufferVolume = bufferVolume; // buffered volume in mm³
  targetObject.userData.boxSize = {
    x: boxSize.x,
    y: boxSize.y,
    z: boxSize.z,
  };
  targetObject.userData.bufferBoxSize = {
    x: bufferedWidth,
    y: bufferedHeight,
    z: bufferedDepth,
  };

  return targetObject;
}
